import { LessonProblem } from '@yandex-int/k-common/typings';

export const filterLoadedLessonProblems = (lessonProblems: LessonProblem[]) => {
    return lessonProblems.filter((problem) => problem?.problem?.markup);
};
